
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class BubbleCard extends Vue {
// Available color classes: Teal, Navy & Peach
@Prop({ default: 'teal', type: String }) private readonly cardColor!: string;

get computedTitleClass(): string {
  return `bubble-card__title bubble-card__title--${this.cardColor}`;
}
}
